import React, { useCallback } from 'react'
import Button from '../../../../ui/button'
import { CheckIcon, ClearIcon } from '../../../../ui/icon'
import { TileDragObject } from '../../dragObjects'
import { HandTile } from '../../models'
import Bag from './Bag'
import styles from './Controls.module.css'
import Hand from './Hand'

interface ControlsProps {
    bagSize: number
    handTiles: HandTile[]
    canTrade: boolean
    canReset: boolean
    canSubmit: boolean
    onTakeBack: (x: { tileId: number }) => any
    onTrade: (x: { tileId: number }) => any
    onReset: () => any
    onSubmit: () => any
}

export default function Controls(props: ControlsProps) {
    const { onTakeBack, onTrade, onReset, onSubmit } = props
    const handleTakeBack = useCallback(({ id }) => onTakeBack({ tileId: id }), [onTakeBack])
    const handleTrade = useCallback(({ id }) => onTrade({ tileId: id }), [onTrade])
    const handleReset = useCallback(() => onReset(), [onReset])
    const handleSubmit = useCallback(() => onSubmit(), [onSubmit])

    return (
        <div className={styles.root}>
            <div className={styles.bag}>
                <Bag<TileDragObject>
                    numTiles={props.bagSize}
                    canTrade={props.canTrade}
                    onTrade={handleTrade}
                />
            </div>
            <div className={styles.hand}>
                <Hand<TileDragObject>
                    tiles={props.handTiles}
                    onTakeBack={handleTakeBack}
                />
            </div>
            <div className={styles.actions}>
                <Button
                    variant="contained"
                    icon={CheckIcon}
                    disabled={!props.canSubmit}
                    onClick={handleSubmit}
                />
                <Button
                    variant="outlined"
                    icon={ClearIcon}
                    disabled={!props.canReset}
                    onClick={handleReset}
                />
            </div>
        </div>
    )
}